import Header from "@/components/Header";
import Footer from "@/components/Footer";
import PageBackground from "@/components/PageBackground";
import ScrollReveal from "@/components/ScrollReveal";
import SEO from "@/components/SEO";

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      <PageBackground />
      <div className="relative z-10">
      <SEO title="Datenschutz – 4Facemedia" description="Datenschutzerklärung der Kreativagentur 4Facemedia, Bochum." path="/datenschutz" />
      <Header />

      <section className="pt-32 pb-20 bg-gradient-hero">
        <div className="container mx-auto px-4">
          <ScrollReveal>
            <h1 className="text-5xl md:text-7xl font-bold text-foreground mt-4 mb-6">
              Datenschutz
            </h1>
          </ScrollReveal>
        </div>
      </section>

      <section className="py-20">
        <div className="container mx-auto px-4 max-w-3xl">
          <ScrollReveal>
            <div className="prose prose-invert max-w-none space-y-8 text-foreground/85 font-light leading-relaxed">
              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">1. Datenschutz auf einen Blick</h2>
                <h3 className="text-lg font-medium text-foreground mb-2">Allgemeine Hinweise</h3>
                <p>
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">2. Verantwortliche Stelle</h2>
                <p>
                  4FaceMedia<br />
                  Karl Leich Straße 7a<br />
                  44805 Bochum<br />
                  E-Mail: info@4facemedia.de<br />
                  Telefon: +49 173 235 4407
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">3. Datenerfassung auf unserer Website</h2>
                <h3 className="text-lg font-medium text-foreground mb-2">Kontaktformular</h3>
                <p>
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">4. Hosting</h2>
                <p>
                  Unsere Website wird bei einem externen Dienstleister gehostet (STRATO AG). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">5. Ihre Rechte</h2>
                <p>
                  Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-foreground mb-4">6. Cookies</h2>
                <p>
                  Unsere Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
                </p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </section>

      <Footer />
      </div>
    </div>
  );
};

export default Datenschutz;
